import React, { useState } from 'react';
import CheckboxSwitchModel from "./CheckboxSwitchModel"
import './CheckboxSwitch.css'

interface Props
{
    conf: CheckboxSwitchModel
    index?: number
    className?: string
    onChange?: (e: any, conf: any) => boolean;
    onChangeAsync?: (e: any, conf: any) => Promise<boolean>;
    style?: any
}

export default function CheckboxSwitch(props: Props)
{
    const [active, setActive] = useState(props.conf.active)
    async function onChange(e: any)
    {
        e.preventDefault();
        let v = !active;

        let conf = { field: props.conf.fieldName, active: v, index: props.index ?? 0 };
        if (props.onChange) {
            let result = props.onChange(e, conf);
            if (result)
                setActive(v);
        } else if (props.onChangeAsync) {
            let result = await props.onChangeAsync(e, conf);
            if (result)
                setActive(v);
        } else
            setActive(v);
    }

    return (
        <div className={(props.className ?? '') + " switch" + (active ? " on" : " off")} style={props.style} translate="no">
            <input type="hidden" value={active ? active.toString() : 'false'} name={props.conf.fieldName} />
            <label onClick={onChange}>
                {props.conf.textDeactivate}
                <span className="switch-lever" />
                {props.conf.textActive}
            </label>
        </div>
    );
}

